module.exports = __webpack_public_path__ + "img/icon9.7c69ef89.png";